import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

export default class MeusChamados extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        const url = `/api/suporte/meusChamados/${localStorage.nome}`
        axios(url)
            .then(resp => {
                this.setState({ list: resp.data })
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }

    arquiva(id) {
        const url = '/api/suporte/arquiva'
        axios.post(url, {id})
            .then(res => {
                alert(res.data)
                window.location = `/meusChamados`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    render() {
        return (
            <div className="container mx-auto">
                <div className="form-group row pt-3 text-center">
                <label className="col-12 mt-5 text-left"><b>PENDENTES:</b></label>
                    <table className="table mt-4">
                        <thead>
                            <tr>
                                <th>NÚMERO</th>
                                <th>DATA</th>
                                <th>TIPO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRows()}
                        </tbody>
                    </table>
                <label className="col-12 mt-5 text-left"><b>RESPONDIDOS:</b></label>
                    <table className="table mt-4">
                        <thead>
                            <tr>
                                <th>NÚMERO</th>
                                <th>DATA</th>
                                <th>TIPO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRespostas()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderRows() {
        let select = []
        if (this.state.list) {
            this.state.list.map(suporte => {
                if(!suporte.arquivado && !suporte.resposta) {
                    select.push(
                        <tr key={suporte.numero}>
                            <td>{suporte.numero}</td>
                            <td>{suporte.data}</td>
                            <td>{suporte.tipo}</td>
                            <td>
                                <Link to={`/chamado/${suporte._id}`} target="_blank">
                                    <button className="btn btn-warning">Abrir</button>
                                </Link>
                                    <button className="btn btn-danger ml-2" onClick={e => this.arquiva(suporte._id)}>Arquivar</button>
                            </td>
                        </tr>
                    )
                }
            })
        }
        return select
    }

    renderRespostas() {
        let select = []
        if (this.state.list) {
            this.state.list.map(suporte => {
                if(!suporte.arquivado && suporte.resposta) {
                    select.push(
                        <tr key={suporte.numero}>
                            <td>{suporte.numero}</td>
                            <td>{suporte.data}</td>
                            <td>{suporte.tipo}</td>
                            <td>
                                <Link to={`/chamado/${suporte._id}`} target="_blank">
                                    <button className="btn btn-warning">Abrir</button>
                                </Link>
                                    <button className="btn btn-danger ml-2" onClick={e => this.arquiva(suporte._id)}>Arquivar</button>
                            </td>
                        </tr>
                    )
                }
            })
        }
        return select
    }
}